export default "<h1>Disciplines 设计原则</h1>\n"